import React from 'react';
import { SCHEDULER_URL } from '../../constants';

function CtaSection() {
  return (
    <section
      className="py-16 md:py-24 text-center bg-gradient-to-br from-navy to-navy-deep"
      id="pilots"
    >
      <div className="max-w-[1180px] mx-auto px-6 md:px-8">
        <h2 className="font-display text-[1.8rem] md:text-[2.1rem] font-bold text-cream-hi">
          Bring Goldie to your community.
        </h2>
        <p className="text-cream-hi/85 max-w-[520px] mx-auto my-4 mb-[30px] leading-[1.6]">
          We&apos;re running paid pilots now with senior living operators across the country.
          Let&apos;s find the right fit for your residents and your staff.
        </p>
        <a
          href={SCHEDULER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-4 rounded-full bg-cream-hi text-navy-deep font-bold transition-transform hover:-translate-y-0.5 outline-none focus-visible:ring-2 focus-visible:ring-sky focus-visible:ring-offset-2 focus-visible:ring-offset-navy-deep"
        >
          Start a Pilot Conversation
        </a>
      </div>
    </section>
  );
}

export default CtaSection;
